import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { SetIFrame } from 'src/app/shared/models/node';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { iframeResizer } from 'iframe-resizer';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-sample-webform',
  templateUrl: './sample-webform.component.html',
  styleUrls: ['./sample-webform.component.scss']
})
export class SampleWebformComponent implements OnInit, AfterViewInit {

  @Input() block: SetIFrame = {} as SetIFrame;
  public safeHTML: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer,
              private helpersService: HelpersService) {}

  ngAfterViewInit(): void {
    if(this.helpersService.isBrowser) {
      iframeResizer({ checkOrigin: false }, '.webform-share-iframe');
    }
  }

  ngOnInit(): void {
    const decodedIframeCode = this.decodeHtmlEntities(this.block.codice_iframe);
    this.safeHTML = this.sanitizer.bypassSecurityTrustHtml(decodedIframeCode);
  }
  
  private decodeHtmlEntities(encodedString: string): string {
    if (this.helpersService.isBrowser) {
      const textArea = document.createElement('textarea');
      textArea.innerHTML = encodedString;
      return textArea.value;
    } else {
      return "";
    }
  }

}
